import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
const formatTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (mins === 0) {
        return `${hours}h`;
    }
    if (hours === 0) {
        return `${mins} min`;
    }
    return `${hours}h ${mins} min`;
};
export function TimeFormatter({ children }) {
    return (_jsx(Fragment, { children: formatTime(children) }));
}
